import { onAjaxContentLoaded } from '../js/generic/evented'
import Collection from '../js/generic/collection'
import { getCfg } from './utils/getCfg'
import { getObjFromFormData } from './utils/getObjFromFormData'

export class NextStep {

  state = {
    selectedItem: false
  };

  els = {
    form: '[data-js-next-step-form]',
  };

  attrs = {
    hint: "data-js-next-step-hint",
    text: "data-js-next-step-text"
  }

  constructor (instance) {
    this.instance = instance
    this.form = instance.querySelector(this.els.form)
    this.cfg = getCfg(instance, NextStepCollection.selectors.instance, NextStepCollection.defaultCfg)
    if(!!this.cfg?.relatedFormId) {
      this.relatedForm = document.getElementById(this.cfg.relatedFormId);
    }
    if (this.form) {
      this.submitButtons = Array.from(this.form.elements).filter(element => element.type.toLowerCase() === "submit");
      this.checkSelection()
      this.bindEvents()
    }

  }
  handleSubmit(e) {
    if (!this.state.selectedItem) {
      e.preventDefault()
    } else {
      if(!!this.relatedForm) {
        e.preventDefault()
        let data;
        data = getObjFromFormData(new FormData(this.relatedForm))
        const url = this.form.action
        const method = this.form.method

        // TODO: add post method processing (?)
        // if(method.toLowerCase() === "post") {
        //   console.debug("post")
        // }
        if(method.toLowerCase() === "get") {
          const redirectUrl = new URL(url)
          Object.entries(data).forEach(([key, value]) => {
            redirectUrl.searchParams.set(key, value)
          })
          window.location.href = redirectUrl.toString()
        }
      } else {
        // console.debug("Отправляем данные", window.App.CatalogFilter)
        this.form.submit()
      }
    }
  }

  getDefaultIsValid() {
    return Array.from(this.form.elements).some(element => {
      if (element.type === 'radio' || element.type === 'checkbox') {
        return element.checked;
      }
      return false;
    })
  }

  getRequiredInputNamesValid() {
    if(!!this.relatedForm) {
      let data;
      data = getObjFromFormData(new FormData(this.relatedForm))
      return this.cfg.requiredInputNames.every((inputName) => {
        return !!data[inputName]
      })
    } else {
      return true
    }
  }

  checkSelection() {
    const isValid = !!this.cfg?.requiredInputNames?.length ? this.getRequiredInputNamesValid() : this.getDefaultIsValid()
    this.state.selectedItem = isValid
    this.submitButtons.forEach( el => {
      el.disabled = !isValid;
      this.setTextForButton(el, !isValid)
    } )
  }

  setTextForButton(el, isHint) {
    const hintText = el.getAttribute(this.attrs.hint)
    const text = el.getAttribute(this.attrs.text)
    if (hintText && isHint) {
      el.innerText = hintText
    }
    if (!hintText && isHint) {
      el.innerText = "Выберите позицию для продолжения"
    }
    if (text && !isHint) {
      el.innerText = text
    }
    if (!text && !isHint) {
      el.innerText = "Продолжить"
    }
  }
  bindEvents() {
    this.form.addEventListener("submit", (e) => {
      this.handleSubmit(e)
    })

    Array.from(this.form.elements).forEach(element => {
      if (element.type === 'radio') {
        element.addEventListener('change', () => this.checkSelection());
      }
    });

    if(!!this.relatedForm) {
      Array.from(this.relatedForm.elements).forEach(element => {
        if (element.type === 'radio') {
          element.addEventListener('change', () => this.checkSelection());
        }
      });
    }

  }
}

export class NextStepCollection extends Collection {
  static selectors = {
    instance: '[data-js-js-next-step]',
  }

  static defaultCfg = {
    relatedFormId: null,
    requiredInputNames: [],
  }

  init (context = document) {
    $(NextStepCollection.selectors.instance).each((index, el) => {
      const instance = this.collection.find(element => element.instance === el)
      if (!instance) {
        this.collection = new NextStep(el)
      }
    })
  }

  constructor() {
    super(NextStepCollection.selectors.instance, NextStep)
    this.init()
    this.bindEvents();
  }

  bindEvents () {
    onAjaxContentLoaded(() => {
      this.init()
    })
  }
}
